import TitleBar from "../../../components/common/TitleBar";
import CustomSegment from "../../../components/ui/CustomSegment";
import { useSegment } from "../../../hooks/useSegment";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { SegmentedType } from "../../../types";
import Contract from "./_components/Contract";
import KPIPerformance from "./_components/KPIPerformance";
import ShiftHistory from "./_components/ShiftHistory";
import SlabHistory from "./_components/SlabHistory";
type SegmentType =
  | "shift-history"
  | "kpi-performance"
  | "slab-history"
  | "contract";

const JobDetails = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    "job-details-segment",
    "shift-history",
    false
  );

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      key: "shift-history",
      label: "Shift History",
      element: <ShiftHistory />,
    },
    {
      key: "kpi-performance",
      label: "KPI Performance",
      element: <KPIPerformance />,
    },
    {
      key: "slab-history",
      label: "Slab History",
      element: <SlabHistory />,
    },
    {
      key: "contract",
      label: "Contract",
      element: <Contract />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.key === segment);

  return (
    <SidebarLayout title="My Projects">
      <TitleBar backLink={-1 as unknown as string} title="Details" />
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
        className="!bg-transparent mt-0 mx-0 !px-0 border-b border-b-light"
      />
      <div className="mt-5">{currentSegment?.element}</div>
    </SidebarLayout>
  );
};

export default JobDetails;
